module.exports = __webpack_public_path__ + "static/media/resources-icon.e60ad047.svg";